import { deleteWorkItem } from "../../../services/workItem";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOG } from "../../workLog/queries/useQueryWorkLog";
import { QUERY_WORK_LOGS } from "../../workLog/queries/useQueryWorkLogs";
import { QUERY_WORK_LOGS_SUMMARY } from "../../workLog/queries/useQueryWorkLogsSummary";
import { QUERY_WORK_ITEMS } from "../queries/useQueryWorkItems";

export const useMutationDeleteWorkItem = () =>
  useWSMutation<
    void,
    WSServiceError,
    {
      workItemId: string;
    }
  >(data => deleteWorkItem(data.workItemId), {
    dependencies: [
      QUERY_WORK_ITEMS,
      QUERY_WORK_LOG,
      QUERY_WORK_LOGS,
      QUERY_WORK_LOGS_SUMMARY
    ]
  });
